// constants/qa.js
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-11 16:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0
//
// QA panel constants: issue colours, confidence colours, and status labels.

export const ISSUE_COLORS = {
  mistranslation:    '#e50914',
  omission:          '#ff6b35',
  hallucination:     '#ff9500',
  unclear_audio:     '#8e8e93',
  historical_term:   '#007aff',
  flattened_context: '#5856d6',
  minor_phrasing:    '#34c759',
};

export const CONFIDENCE_COLORS = {
  high:   '#34c759',
  medium: '#ff9500',
  low:    '#8e8e93',
};

export const STATUS_LABELS = {
  flagged:       'FLAGGED',
  auto_fixed:    'AUTO-FIXED',
  reviewed:      'REVIEWED',
  audio_review:  'AUDIO REVIEW',
  dismissed:     'DISMISSED',
  archival_note: 'ARCHIVAL NOTE',
};
